"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var TicketStage = (0, _immutable.Record)({
  displayOrder: -1,
  label: '',
  stageId: undefined,
  pipelineId: undefined,
  portalId: undefined,
  metadata: (0, _immutable.Map)()
}, 'TicketStage');

TicketStage.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  return TicketStage(json);
};

var _default = TicketStage;
exports.default = _default;
module.exports = exports.default;